module.exports = __webpack_public_path__ + "img/symbol_10.0359bf96.png";